module.exports = __webpack_public_path__ + "static/media/matching-score-board.b255a20f.png";